import { FC, ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type UserMessageProps = {
  children: ReactNode;
  timestamp: string;
};

export const UserMessage: FC<UserMessageProps> = ({
  children,
  timestamp,
}): JSX.Element => {
  return (
    <Box display='flex' flexDirection='column' alignItems='flex-end'>
      <Box
        sx={{
          backgroundColor: 'primary.main',
          borderRadius: '10px 0px 10px 10px',
          color: '#000',
          p: 1,
        }}
      >
        <Typography variant='body1' color={'#fff'} p={0.5}>
          {children}
        </Typography>
      </Box>
      <Typography variant='subtitle2' color={'primary.main'}>
        {timestamp}
      </Typography>
    </Box>
  );
};
